export function partnersInfoNumbersSlider() {
    let sliderNumbers = $(".partners-info-numbers");
    sliderNumbers.each(function () {
        $(this).not('.slick-initialized').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/partnersInfoNumbersSlider.js